import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Loader } from '@src/shared/ui/components/Loader';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { motion } from 'framer-motion';
import { isEmpty, isEqual, isUndefined } from 'lodash';
import React, { useRef } from 'react';

import { useWizardContext } from '../../../context';
import { Footer } from './Footer';
import { Header } from './Header';

/**
 * Layout
 *
 * Glues together the various pieces of the layout.
 *
 * @param children
 * @param defaultValues
 * @param form
 * @param handleSubmit
 * @param isCurrentStepValid
 * @param isLoading
 * @returns {Element}
 * @constructor
 */
export function Layout({
  children,
  defaultValues = {},
  form = {},
  handleSubmit = () => {},
  isCurrentStepValid = true,
  isLoading = false,
}) {
  const { action, actionPath } = useWizardContext();

  const containerRef = useRef();

  const formValues = form?.getValues();

  const hasActionPath = !isUndefined(actionPath) && !isEmpty(actionPath);
  const hasDefaultValues = isEqual(formValues, defaultValues);

  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/misc/Layout/Layout.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          {isLoading || (action === 'edit' && hasDefaultValues) || (action === 'edit' && !hasActionPath) ? (
            <Grid.Col
              span={{
                xs: '100%',
              }}
            >
              <Loader verticalAlignment="start" />
            </Grid.Col>
          ) : (
            [
              <Grid.Col
                key="header"
                span={{
                  xs: '100%',
                }}
              >
                <Header form={form} handleSubmit={form?.handleSubmit(handleSubmit, () => {})} />
              </Grid.Col>,
              <Grid.Col
                key="footer"
                span={{
                  xs: '100%',
                }}
              >
                <div ref={containerRef}>
                  {children}
                  <Footer
                    form={form}
                    handleSubmit={form?.handleSubmit(handleSubmit, () => {})}
                    isCurrentStepValid={isCurrentStepValid}
                  />
                </div>
              </Grid.Col>,
            ]
          )}
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
